"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _configContext = require("../../page-header/marquees/mega-marquee/config-context");
var _useElementProps = _interopRequireDefault(require("@site/pattern-library-utils/hooks/useElementProps"));
var _marqueePicture = _interopRequireDefault(require("../../page-header/marquees/common/marquee-picture"));
var _index = _interopRequireDefault(require("../../elements/other/actions/index"));
var _functions = require("./functions");
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var _base = require("@site/pattern-library-utils/base.functions");
var _inlineVideo = _interopRequireDefault(require("../../elements/other/inline-video"));
require("../../page-header/marquees/mega-marquee/common/marquee-rtb");
require("../../page-header/marquees/mega-marquee/common/trustpilot");
require("../../elements/other/domain-search-bar");
// eslint-disable-next-line import/no-unassigned-import

// eslint-disable-next-line import/no-unassigned-import

// eslint-disable-next-line import/no-unassigned-import

const ctaContainer = "pl-c1si3d5";
const disclaimerStyle = "pl-d1080xnb";
const contentContainer = "pl-c1rt0gpi";
const mediaContainer = "pl-msscoak";
const container = "pl-c1t9ohag";
const truspilotBarDesktopOnly = "pl-t14rbjjy";
const trustpilotBarMobileOnly = "pl-t1o8h76j";
const section = "pl-s1xvfzn3";
const getTrustpilotContainerClass = layout => (0, _core.cx)('stacked-trustpilot', layout !== 'stacked' && trustpilotBarMobileOnly);
function Disclaimer({
  disclaimer,
  disclaimerTooltip,
  dataPartial
}) {
  if (!disclaimer) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-partial": dataPartial
  }, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "paragraph",
    size: -2,
    "data-cy": "disclaimer",
    className: disclaimerStyle,
    text: disclaimer,
    tooltip: disclaimerTooltip
  }));
}
function CTAContainer({
  ctas,
  dataPartial
}) {
  if (!ctas) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "cta-container",
    className: ctaContainer,
    "data-partial": dataPartial
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: ctas
  }));
}
function TrustpilotDesktopOnly({
  layout,
  trustpilotBar
}) {
  if (layout === 'stacked') return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: truspilotBarDesktopOnly
  }, trustpilotBar);
}
function hasVideoContent(videoProps) {
  if (!videoProps) return false;
  const {
    introUrl,
    introUrlWebm,
    introUrlLaptop,
    introUrlLaptopWebm,
    videos
  } = videoProps;
  return introUrl || introUrlWebm || introUrlLaptop || introUrlLaptopWebm || videos && /*#__PURE__*/_react.default.isValidElement(videos);
}
function MediaContent({
  portrait,
  landscape,
  videoProps
}) {
  const hasVideo = hasVideoContent(videoProps);
  const hasImage = portrait?.url || landscape?.url;
  if (!hasVideo && !hasImage) return null;
  const imageComponent = hasImage ? /*#__PURE__*/_react.default.createElement(_marqueePicture.default, {
    portrait: portrait,
    landscape: landscape,
    imgLoading: "eager"
  }) : null;
  const videoComponent = hasVideo ? /*#__PURE__*/_react.default.createElement(_inlineVideo.default, (0, _extends2.default)({}, videoProps, {
    loop: true
  })) : null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imageComponent, videoComponent);
}

/**
 * DomainSearchMarquee Component.
 *
 * @param {Object} props React props
 * @param {string} props.id Section ID
 * @param {string} props._name Section Name
 * @param {Object} props.headlineLockup Headline Lockup
 * @param {Object} props.rtbList Marquee RTB Component
 * @param {Object} props.trustpilotBar Trustpilot Component
 * @param {Object} props.domainSearch Domain Search Component
 * @param {Array} props.domainSearchTlds Array of TLD objects (TODO: move to domainSearch object during operationalization)
 * @param {string} props.tldMoreButtonText Text for the more button
 * @param {string} props.tldMoreButtonUrl URL for the more button
 * @param {string} props.layout Layout variant - 'image-right', 'image-left', or 'stacked'
 * @param {Object} props.portrait Mobile Image
 * @param {Object} props.landscape Desktop Image
 * @param {string} props.partial Partial for the section
 * @param {Object} props.disclaimer Disclaimer
 * @returns {React.ReactElement} DomainSearchMarquee Component
 * @public
 */
function DomainSearchMarquee({
  id,
  _name,
  layout = 'stacked',
  headlineLockup,
  rtbList,
  trustpilotBar,
  domainSearch,
  domainSearchTlds,
  tldMoreButtonText,
  tldMoreButtonUrl,
  portrait = {},
  landscape = {},
  partial = '',
  invert = false,
  thumbnailDesktop,
  thumbnailMobile,
  introUrl,
  introUrlWebm,
  introUrlLaptop,
  introUrlLaptopWebm,
  videos,
  preload,
  hidePlayButton = false
}) {
  const dataPartial = (0, _base.getDataPartial)(partial, invert);
  const textAlign = (0, _functions.getTextAlign)(layout, headlineLockup);
  const ctas = headlineLockup?.props?.ctas;
  const disclaimer = headlineLockup?.props?.disclaimer;
  const disclaimerTooltip = headlineLockup?.props?.disclaimerTooltip;
  const {
    props: domainSearchProps
  } = domainSearch || {};
  const processedHeadlineLockup = (0, _useElementProps.default)(headlineLockup, {
    textAlign,
    headlineSize: headlineLockup?.props?.headlineSize || 'h2',
    invert: invert,
    disclaimer: null,
    disclaimerTooltip: null,
    ctas: null
  });
  const processedDomainSearch = (0, _useElementProps.default)(domainSearch, {
    domainSearch: domainSearchProps,
    tlds: domainSearchTlds,
    tldMoreButtonText: tldMoreButtonText,
    tldMoreButtonUrl: tldMoreButtonUrl
  });
  const layoutProps = (0, _functions.getLayoutProps)(layout);
  return /*#__PURE__*/_react.default.createElement(_configContext.ConfigContext.Provider, {
    value: {
      layout
    }
  }, /*#__PURE__*/_react.default.createElement(_section.default, {
    id: `id-${id}`,
    _name: _name,
    dataCy: "domain-search-marquee",
    verticalMargin: "none",
    className: section,
    partial: partial,
    backgroundColor: "transparent"
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: container
  }, layoutProps), /*#__PURE__*/_react.default.createElement("div", {
    className: contentContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "headline-content multibrand-app",
    "data-partial": dataPartial
  }, processedHeadlineLockup, rtbList), processedDomainSearch, /*#__PURE__*/_react.default.createElement(Disclaimer, {
    disclaimer: disclaimer,
    disclaimerTooltip: disclaimerTooltip,
    dataPartial: dataPartial
  }), /*#__PURE__*/_react.default.createElement(CTAContainer, {
    ctas: ctas,
    dataPartial: dataPartial
  }), /*#__PURE__*/_react.default.createElement(TrustpilotDesktopOnly, {
    layout: layout,
    trustpilotBar: trustpilotBar
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: mediaContainer,
    "data-partial": "boxRadiusLarge"
  }, /*#__PURE__*/_react.default.createElement(MediaContent, {
    portrait: portrait,
    landscape: landscape,
    videoProps: {
      introUrl,
      introUrlWebm,
      introUrlLaptop,
      introUrlLaptopWebm,
      thumbnailDesktop,
      thumbnailMobile,
      videos,
      preload,
      hidePlayButton
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: getTrustpilotContainerClass(layout)
  }, trustpilotBar)));
}
var _default = exports.default = DomainSearchMarquee;
DomainSearchMarquee.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  headlineLockup: _propTypes.default.node,
  rtbList: _propTypes.default.node,
  trustpilotBar: _propTypes.default.node,
  domainSearch: _propTypes.default.node,
  domainSearchTlds: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    price: _propTypes.default.string
  })),
  tldMoreButtonText: _propTypes.default.string,
  tldMoreButtonUrl: _propTypes.default.string,
  layout: _propTypes.default.oneOf(['image-right', 'image-left', 'stacked']),
  portrait: _propTypes.default.shape(_boxModelSize.bynderImageProps),
  landscape: _propTypes.default.shape(_boxModelSize.bynderImageProps),
  partial: _propTypes.default.string,
  invert: _propTypes.default.bool,
  thumbnailDesktop: _propTypes.default.string,
  thumbnailMobile: _propTypes.default.string,
  introUrl: _propTypes.default.string,
  introUrlWebm: _propTypes.default.string,
  introUrlLaptop: _propTypes.default.string,
  introUrlLaptopWebm: _propTypes.default.string,
  videos: _propTypes.default.node,
  preload: _propTypes.default.string,
  hidePlayButton: _propTypes.default.bool
};
Disclaimer.propTypes = {
  disclaimer: _propTypes.default.string,
  disclaimerTooltip: _propTypes.default.string,
  dataPartial: _propTypes.default.string
};
CTAContainer.propTypes = {
  ctas: _propTypes.default.array,
  dataPartial: _propTypes.default.string
};
TrustpilotDesktopOnly.propTypes = {
  layout: _propTypes.default.oneOf(['image-right', 'image-left', 'stacked']),
  trustpilotBar: _propTypes.default.node
};
MediaContent.propTypes = {
  portrait: _propTypes.default.shape(_boxModelSize.bynderImageProps),
  landscape: _propTypes.default.shape(_boxModelSize.bynderImageProps),
  videoProps: _propTypes.default.shape({
    thumbnailDesktop: _propTypes.default.string,
    thumbnailMobile: _propTypes.default.string,
    introUrl: _propTypes.default.string,
    introUrlWebm: _propTypes.default.string,
    introUrlLaptop: _propTypes.default.string,
    introUrlLaptopWebm: _propTypes.default.string,
    videos: _propTypes.default.node,
    preload: _propTypes.default.string,
    hidePlayButton: _propTypes.default.bool
  })
};